// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import FormOutlined from '/app/node_modules/@ant-design/icons/es/icons/FormOutlined';
import SmileOutlined from '/app/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import TableOutlined from '/app/node_modules/@ant-design/icons/es/icons/TableOutlined';
import UserOutlined from '/app/node_modules/@ant-design/icons/es/icons/UserOutlined';
import KeyOutlined from '/app/node_modules/@ant-design/icons/es/icons/KeyOutlined';
export default { DashboardOutlined, FormOutlined, SmileOutlined, TableOutlined, UserOutlined, KeyOutlined };
